import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHelmet from "@/components/feature/SEOHelmet";
import JsonLd from "@/components/feature/JsonLd";
import { categories } from "@/mocks/categories";

export default function About() {
  const canonicalUrl = "https://whxinantec.cn/about";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料bu打烊",
    url: "https://whxinantec.cn",
    description:
      "全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。",
    email: "contact@whxinantec.cn",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@whxinantec.cn",
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
    sameAs: ["https://weibo.com/heiliao-budayang"],
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 黑料bu打烊",
    description:
      "了解黑料bu打烊的品牌故事、平台口碑与联系方式。全网最全明星艺人黑料聚合平台。",
    url: canonicalUrl,
    isPartOf: {
      "@type": "WebSite",
      name: "黑料bu打烊",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "黑料bu打烊是什么平台？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "黑料bu打烊是一个专注娱乐圈明星八卦黑料的聚合平台，7×24小时不间断更新最新爆料、明星黑料、综艺内幕等娱乐资讯，致力于为广大吃瓜群众提供最全面、最及时的娱乐八卦内容。",
        },
      },
      {
        "@type": "Question",
        name: "平台的爆料内容可信吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们拥有专业的采编团队和广泛的圈内资源网络，每一条爆料均经过多方交叉验证后方才发布。同时我们也开放了用户投稿渠道，鼓励知情人士提供独家线索。",
        },
      },
      {
        "@type": "Question",
        name: "如何向黑料bu打烊投稿？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过邮箱 tips@whxinantec.cn 向我们投稿。所有投稿信息将被严格保密，一经采用即付丰厚稿酬。",
        },
      },
      {
        "@type": "Question",
        name: "平台更新频率如何？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们实行7×24小时不间断更新机制，确保用户随时随地都能获取最新最热的娱乐圈爆料内容。平均每日更新超过50条独家资讯。",
        },
      },
      {
        "@type": "Question",
        name: "如何联系商务合作？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "商务合作请发送邮件至 biz@whxinantec.cn，我们的商务团队将在1-3个工作日内与您联系。我们欢迎广告投放、内容合作、品牌联名等多种合作方式。",
        },
      },
    ],
  };

  const teamMembers = [
    {
      name: "黑料侦探",
      role: "首席调查记者",
      description: "深耕娱乐圈调查报道十余年，擅长挖掘明星背后的真实故事。",
      imageUrl: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20journalist%20in%20modern%20newsroom%2C%20warm%20lighting%2C%20friendly%20confident%20expression%2C%20editorial%20style%20headshot%2C%20clean%20simple%20background&width=200&height=200&seq=team-1-2026&orientation=squarish",
    },
    {
      name: "综艺观察员",
      role: "综艺线主编",
      description: "前综艺节目制作人，深谙综艺圈运作内幕与资本逻辑。",
      imageUrl: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20female%20journalist%20in%20office%2C%20warm%20lighting%2C%20friendly%20smile%2C%20editorial%20style%20headshot%2C%20clean%20simple%20background&width=200&height=200&seq=team-2-2026&orientation=squarish",
    },
    {
      name: "片场观察员",
      role: "影视线记者",
      description: "常年驻扎各大影视基地，第一时间获取剧组内部猛料。",
      imageUrl: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20male%20journalist%20with%20camera%2C%20warm%20lighting%2C%20confident%20expression%2C%20editorial%20style%20headshot%2C%20clean%20simple%20background&width=200&height=200&seq=team-3-2026&orientation=squarish",
    },
    {
      name: "情感观察室",
      role: "情感线主编",
      description: "专注明星恋情八卦，拥有丰富的圈内红娘资源网络。",
      imageUrl: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20female%20editor%20in%20modern%20office%2C%20warm%20lighting%2C%20friendly%20expression%2C%20editorial%20style%20headshot%2C%20clean%20simple%20background&width=200&height=200&seq=team-4-2026&orientation=squarish",
    },
  ];

  const testimonials = [
    {
      quote:
        "黑料bu打烊是我每天必看的平台，爆料速度快、内容真实度高，关键是不会像别的平台那样标题党，点进去全是废话。",
      author: "资深吃瓜群众",
      role: "3年老用户",
    },
    {
      quote:
        "这个平台的独家内容是真的多，很多料我第一次看到都是在这里，别家都是跟风转载。编辑部肯定有关系！",
      author: "娱乐博主",
      role: "2年老用户",
    },
    {
      quote:
        "界面干净、分类清晰、没有乱七八糟的弹窗广告，阅读体验在同类平台里绝对是第一梯队的。",
      author: "互联网从业者",
      role: "1年用户",
    },
  ];

  return (
    <>
      <ScrollToTop />
      <SEOHelmet
        title="关于我们 - 黑料bu打烊 | 明星八卦黑料聚合平台"
        description="了解黑料bu打烊的品牌故事、平台口碑与联系方式。黑料bu打烊——全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料。"
        keywords="黑料bu打烊,关于黑料bu打烊,明星黑料平台,吃瓜平台,联系我们"
        canonicalUrl={canonicalUrl}
      />
      <JsonLd data={organizationSchema} />
      <JsonLd data={webpageSchema} />
      <JsonLd data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: "首页", path: "/" },
                  { label: "关于我们" },
                ]}
              />
            </div>
          </div>

          {/* Hero */}
          <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20newsroom%20with%20journalists%20working%20at%20desks%2C%20warm%20ambient%20lighting%2C%20professional%20media%20company%20office%2C%20editorial%20team%20collaboration%2C%20creative%20workspace%20with%20monitors%20and%20notes%2C%20stylish%20industrial%20interior%20with%20exposed%20brick%20and%20warm%20wood%20accents&width=1600&height=800&seq=about-hero-2026&orientation=landscape"
              alt="黑料bu打烊团队"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-white mb-3">
                关于黑料bu打烊
              </h1>
              <p className="text-sm md:text-base text-white/70 max-w-xl">
                全网最全明星艺人黑料聚合平台
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="max-w-3xl mx-auto text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <p className="text-foreground-600 leading-relaxed">
                  黑料bu打烊成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们拥有一支专业的采编团队和广泛的圈内资源网络，致力于为全国数千万吃瓜群众提供最新、最全、最真实的娱乐圈黑料与八卦资讯。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-eye-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                    独家视野
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    遍布娱乐圈的独家资源网络，让你看到别人看不到的真实内幕。我们拥有超过200位圈内线人，覆盖影视、音乐、综艺全领域。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-speed-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                    极速更新
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    7×24小时不间断更新机制，重大爆料15分钟内即可上线。平均每日推送超过50条独家内容，让你永远走在吃瓜第一线。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-shield-check-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                    严格审核
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    三重审核机制确保内容真实可靠。每一条爆料都经过线人核实、多方交叉验证和编辑终审，拒绝虚假信息。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Coverage Areas */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  覆盖领域
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  从影视圈到音乐圈，从综艺内幕到明星私生活，我们全方位覆盖娱乐圈每一个角落
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {categories.map((cat) => (
                  <div
                    key={cat.slug}
                    className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                      <i
                        className={`${cat.icon} text-accent-600 text-lg`}
                      ></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-800">
                      {cat.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Team */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  我们的团队
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  一群热爱八卦、专注真相的媒体人
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {teamMembers.map((member, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg border border-background-200 p-6 text-center"
                  >
                    <div className="w-20 h-20 mx-auto rounded-full overflow-hidden mb-4">
                      <img
                        src={member.imageUrl}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                      {member.name}
                    </h3>
                    <p className="text-xs text-primary-600 font-medium mb-2">
                      {member.role}
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {member.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  听听吃瓜群众们怎么说
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg border border-background-200 p-6"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className="ri-star-fill text-accent-500 text-sm"
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;{testimonial.quote}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                        <span className="text-xs font-semibold text-accent-700">
                          {testimonial.author.charAt(0)}
                        </span>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">
                          {testimonial.author}
                        </p>
                        <p className="text-xs text-foreground-500">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                  欢迎随时与我们联系，无论是爆料投稿、商务合作还是意见建议
                </p>
              </div>
              <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-send-plane-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    爆料投稿
                  </h3>
                  <a
                    href="mailto:tips@whxinantec.cn"
                    className="text-sm text-primary-600 hover:text-primary-700 transition-colors"
                  >
                    tips@whxinantec.cn
                  </a>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-briefcase-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    商务合作
                  </h3>
                  <a
                    href="mailto:biz@whxinantec.cn"
                    className="text-sm text-primary-600 hover:text-primary-700 transition-colors"
                  >
                    biz@whxinantec.cn
                  </a>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-customer-service-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    客服咨询
                  </h3>
                  <a
                    href="mailto:contact@whxinantec.cn"
                    className="text-sm text-primary-600 hover:text-primary-700 transition-colors"
                  >
                    contact@whxinantec.cn
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}